import { css } from "@emotion/react"
import styled from "@emotion/styled"
import { PTableRow } from "@porsche-design-system/components-react"
import { Link } from "react-router"
import { shouldForwardProp } from "src/common/shouldForwardProp"

export const TableRowWithLink = styled(PTableRow, { shouldForwardProp })<{ $isDisabled?: boolean }>`
	position: relative;
	transform: translateX(0); /* safari */
	${({ $isDisabled }) => $isDisabled && "--_p-table-b: none;"}
	
	a {
		text-decoration: none !important;
	}

	[data-state="open"] {
		cursor: pointer;
	}
`

// pseudo element spans link across entire row
const sharedCss = css`
	&::before {
		content: "";
		position: absolute;
		inset: 0;
	}
`

/** renders a regular link with page reload */
export const TableRowA = styled.a`${sharedCss}`

/** renders a link for react-router routing without reload */
export const TableRowLink = styled(Link)`${sharedCss}`
